export enum TokenLabels {
    Bankx = 'BankX',
    Bnb = 'BNB',
    Erc = 'Erc',
    Xsd = 'XSD',
}
